import { Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import * as React from "react";
import Page from "./Page";
import moment from "moment";
import {CyNumber} from "../../../utilities/number";

const styles = (theme) => ({
  root: {
    '& .prim-color-highlight': {
      color: theme.palette.primary.main
    },
  },
});


/**
 * Render a Disclosure, Disclosure should be html content with page separators in it.
 * 
 * To break down pages, separate page content with <!--page--> html comment.
 * TO add a header in the page include raw HTML in this format
 * 
 * <h5 class="MuiTypography-root MuiTypography-h5 MuiTypography-gutterBottom">My Header</h5>
 * @param {*} param0 
 * @returns 
 */
const IndividualDisclosure = withStyles(styles)((
  { disclosure, portfolio, classes, showTitle = false, data }
) => {
  /**
   * @type {string}
   */
  let cleanDisclosure = disclosure;
  if (data) {
    cleanDisclosure = cleanDisclosure
      .replace('[MC_PORTFOLIO_RETURN]', CyNumber.PercentageParser(data['MC_PORTFOLIO_RETURN']) || '')
      .replace('[MC_STANDARD_DEVIATION]', CyNumber.PercentageParser(data['MC_STANDARD_DEVIATION']) || '')
      .replace(
        '[MC_START_DATE]',
        moment(data['MC_START_DATE'])
          .subtract(2, 'months')
          .startOf('month')
          .format('MM/DD/YYYY') || '')
  } else {
    cleanDisclosure = cleanDisclosure.replace('mc_data_class', 'hidden')
  }
  return <React.Fragment>
    {
      cleanDisclosure
        .split('<!--page-->')
        .map((__html, i) => {

          const importantInfoTitlePage = (i === 0 ) && showTitle;

          const toc = importantInfoTitlePage ? {
            'data-toc': 'Important Information'
          }: {};

          return <Page portfolio={portfolio} key={`portfolio-disclosures-page-${i}`}>
            {/* Page 1 */}
            {
              importantInfoTitlePage && <Grid container={true} spacing={3}>
                  <Typography variant={'h4'} gutterBottom={true}>
                    Important Information
                  </Typography>
              </Grid>
            }
            {/* End Page 1 */}
            <section className={`content disclaimer-and-disclosure ${classes.root}`} {...toc} >
              <Grid container={true} spacing={3}>
                <section dangerouslySetInnerHTML={{ __html }}>
                </section>
              </Grid>
            </section>
          </Page>
        })
    }
  </React.Fragment>;
});

const DisclaimersAndDisclosuresSection = ({ app, portfolio, data }) => {
  const { summaryDisclosures, platformDisclosure } = app;
  return summaryDisclosures ? 
  <React.Fragment>
    <IndividualDisclosure disclosure={summaryDisclosures} portfolio={portfolio} showTitle={true} data={data}/>
    <IndividualDisclosure disclosure={platformDisclosure} portfolio={portfolio} data={data}/>
  </React.Fragment>:
  <React.Fragment>
    <IndividualDisclosure disclosure={platformDisclosure} portfolio={portfolio} showTitle={true} data={data}/>
  </React.Fragment>
};



export default DisclaimersAndDisclosuresSection;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/DisclaimersAndDisclosuresSection.jsx